module.exports = __webpack_public_path__ + "img/bg.c2efe6dd.jpg";